/**
       *********************************************************
       Description: Layout for the header component. Needs to be modified a little
       Required props:   options, components, compmap. Each component in components has a alignitem prop to layout the component.
       Another configuration is responsive can be added in the json to make the component responsive. When the screen size
       decreases all the header components that has isresponsive are show as a menu.
       limitations    : N/A
       *********************************************************
       **/
import { CssBaseline, List, Popover } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Badge from '@material-ui/core/Badge';
import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import { withStyles } from '@material-ui/core/styles';
import SupportIcon from '@material-ui/icons/ContactSupport';
import HomeIcon from '@material-ui/icons/Home';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationIcon from '@material-ui/icons/NotificationsActive';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getEnvVariable } from '../../../../modules/environmentalList';
import { getProjectMessages, leftmenuDrawerOpen, moveSidebartoTop, setNotifications } from '../../../actions';
import { GetData, PostData } from '../../../controls/helpers/requests';
import { getSignInToken } from '../../../modules/header';
import { setProfile } from '../../../security/actions';
import SidebartabView from '../../sidebar/menutabs';
import Sidebar from '../../sidebar/sidebar';
import { getLandingPagelogo } from './ImageLogos';
import RightDrawer from './profilepopover';
const _ = require('lodash');


const styles = theme => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        borderBottom: `1px solid ${theme.palette.primary.dark}`,
        boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
        '& .MuiToolbar-dense': {
            minHeight: 28,
            paddingTop: 0,
            paddingBottom: 0,
        },
    },
    grow: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'inline',
        // Removed display property
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'contents',
        },
        height: 'inherit',
    },
    sectionNonDesktop: {
        // display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'contents',
        },
        height: 'inherit',
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
        height: 'inherit',
    },
});
const arr = localStorage.getItem('submodule') && JSON.parse(localStorage.getItem('submodule')) ? JSON.parse(localStorage.getItem('submodule')) : []

class MuiEdgeLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            mobileMoreAnchorEl: null,
            userProfile: {},
            landinglogo: '',
            moveSidebartoTop: 'N',
            rowClickedData: {},
            fontSizeTitle: '20px',
            fontSizeSubtitle: '23px',
            fontSizeModuleKey: '45px',
            fontSizeCaption: '1.35vw',
            imgHeight: '120px',
            imgWidth: '120px',
            rightTitleBlockWidth: 'unset'
        };
        this.handleResize = this.handleResize.bind(this);
    }


    componentDidMount() {
        this.loadInitialGrid();
        this.props.leftmenuDrawerOpen(localStorage.getItem('menulistview') && localStorage.getItem('menulistview') !== 'Y');
        window.addEventListener('resize', this.handleResize);
        this.handleResize(); // Call once to set initial size
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        const screenWidth = window.innerWidth;
        if (screenWidth <= 476) {
            this.setState({
                fontSizeTitle: '12px',
                fontSizeSubtitle: '13px',
                fontSizeModuleKey: '20px',
                fontSizeCaption: '1.32vw',
                imgHeight: '60px',
                imgWidth: '60px',
                rightTitleBlockWidth: '100%',
            });
        } else if (screenWidth <= 576) {
            this.setState({
                fontSizeTitle: '12px',
                fontSizeSubtitle: '13px',
                fontSizeModuleKey: '35px',
                fontSizeCaption: '1.32vw',
                imgHeight: '60px',
                imgWidth: '60px',
                rightTitleBlockWidth: '100%',
            });
        }
        else if (screenWidth <= 800) {
            this.setState({
                fontSizeTitle: '18px',
                fontSizeSubtitle: '19px',
                fontSizeModuleKey: '35px',
                fontSizeCaption: '1.3vw',
                imgHeight: '100px',
                imgWidth: '100px',
                rightTitleBlockWidth: '99%'
            });
        } else if (screenWidth <= 858) {
            this.setState({
                fontSizeTitle: '18px',
                fontSizeSubtitle: '19px',
                fontSizeModuleKey: '30px',
                fontSizeCaption: '1.3vw',
                imgHeight: '100px',
                imgWidth: '100px',
                rightTitleBlockWidth: '99%'
            });
        } else {
            this.setState({
                fontSizeTitle: '20px',
                fontSizeSubtitle: '23px',
                fontSizeModuleKey: '35px',
                fontSizeCaption: '1.32vw',
                imgHeight: '120px',
                imgWidth: '120px',
                rightTitleBlockWidth: 'unset'
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.profile) {
            let url = getEnvVariable('AccessPortal') === 'I' ? getEnvVariable('MasterAdmin') + `/api/${getEnvVariable('AppModuleKey')}InternalUser/UserById/` : getEnvVariable('MasterAdmin') + `/api/ExternalUser/` + getEnvVariable('ModuleKey') + `/`;
            let user = localStorage.getItem('profile') && JSON.parse(localStorage.getItem('profile'))
            if (user.userId) {
                GetData(url + user.userId).then(res => {
                    this.props.setProfile(false)
                    this.setState({ userProfile: res })
                })
            }
        }
    }

    loadInitialGrid = () => {
        let logo = getEnvVariable('ModuleKey') === 'APPS' ? (getEnvVariable('AppBarHeaderLogo') || '') : (getLandingPagelogo() || ''); //let logo = getLandingPagelogo();
        this.setState({ landinglogo: logo }, () => {
            let token = getSignInToken();
            let notificationCount = localStorage.getItem('notificationCount');
            if (token && !notificationCount) {
                this.props.setNotifications();
                const url = getEnvVariable('Report') + `/api/ReportQuery/DashboardNotifications`
                // const url= getEnvVariable('MasterAdmin') + `/api/CompanyInternal/RegistrationRequest/` + getEnvVariable('ModuleKey') + `/GetPending` +
                // `${localStorage.getItem('impersonate') ? '?impersonateFor=' + localStorage.getItem('impersonate') : ''}`
                this.fetchData('POST', url, null, null, true)
            }
        })
    }

    handleNavigation = (url) => {
        this.props.history.push(url)
    }

    handleMenuClose = () => {
        this.setState({ anchorEl: null });
        this.handleMobileMenuClose();
    };

    handleMobileMenuOpen = event => {
        this.setState({ mobileMoreAnchorEl: event.currentTarget });
    };

    handleMobileMenuClose = () => {
        this.setState({ mobileMoreAnchorEl: null });
    };

    handleNotificationClick = () => {
        this.props.history.push('/notifications')
    }

    //added for reload the page when we click on Home button
    handleHomeClick = () => {
        this.props.history.push('/')
        window.location.reload();
    }

    goToRegistrationRequest = (e) => {
        this.props.history.push('/Administration/registrationrequest');
    }

    handleTabClick = (each) => {
        this.props.history.push('/Records/' + each.key);
    }

    CSSBackgroundClasses = (style = '') => {
        let module = getEnvVariable('ModuleKey')
        switch (module) {
            case 'AEPS':
                return { background: 'linear-gradient(to right bottom, #e8eaf6, #00355f)' }
            //return { background: 'linear-gradient(to right bottom, #ffffff , #00355f)' }//#e8eaf6
            case 'WRS':
                return { background: 'linear-gradient(to right bottom,  #003349, #344032)' }
            // case 'AMES':
            //     return { background: 'linear-gradient(to right bottom,  rgb(12, 15, 26), rgb(41,51,82))' }
            case 'UPS':
                return { background: 'linear-gradient(to right bottom,  #004785, #337ab7)' }
            default:
                return { background: '' };
        }
    }

    CSSColorClasses = (style = '') => {
        let module = getEnvVariable('ModuleKey')
        switch (module) {
            case 'AEPS':
                return 'rgba(0, 53, 95, 255)'
            case 'AMES':
                return '#fff'
            default:
                return '';
        }
    }

    handleMenuMovetoTOp = (e) => {
        this.setState({ moveSidebartoTop: e }, () => {
            this.props.leftmenuDrawerOpen(!this.props.leftmenuDrawer)
            this.props.moveSidebartoTop(e)
        })
    }

    toggleDrawer = (e, val) => {
        this.setState({ open: val, anchorEl: val === false ? null : e.currentTarget })
    }

    selectedItmes = (event) => {
        this.setState({ selectedItems: event });
    }

    fetchData(requestType, url, queryParam, body, showAlert = true) {
        const queryStr = queryParam != null ? `${url}?${queryParam}` : `${url}`
        if (requestType === "POST") {
            PostData(`${queryStr}`, body, showAlert)
                .then(response => {
                    //Company Registrations mpved User Approvals
                    //total count based on total records in grid for registration request grid
                    // if (registrationRequest) {
                    //     let url = getEnvVariable('MasterAdmin') + `/api/CompanyInternal/RegistrationRequest/` + getEnvVariable('ModuleKey') + `/Grid`
                    //     GetData(url).then(res => {
                    //         if (res && res.total && res.data) {
                    //             this.setState({
                    //                 count: res.total,
                    //                 totalCount: res.data.filter(a => a.RequestStatus === "Pending").length,
                    //             });
                    //         }
                    //     })
                    // }
                    // else {
                    this.props.setNotifications(response?.data);
                    if (response.value && response.value.data) {
                        this.setState({
                            //  count: finalarr,
                            //   totalCount: sum,
                        });
                    }
                    // }

                })
        }

    }

    getBackgroundStyles() {
        const moduleKey = getEnvVariable('ModuleKey')
        switch (moduleKey && !this.props.user) {
            case 'SHAPES':
            case 'MPS':
            case 'APPS':
                return {
                    backgroundColor: "unset",
                }
            default:
                return {}
        }
    }




    /**
        *********************************************************
        Description: Renders the header.
        Required props:   options, components, compmap. Each component in components has a alignitem prop to layout the component.
            Alignitem has left, right, title for aligning. Isresponsive property  puts the component inside the menu in the mobile screen.
            Alignitem drawer needs to be removed.
        limitations    : N/A
        *********************************************************
        **/

    render() {


        const { options, components, defaults, order, key, type, compmap, handleDrawerOpen, notification, headerTitle } = this.props;
        const { mobileMoreAnchorEl, anchorEl, count, totalCount, rowClickedData,
            fontSizeTitle, fontSizeSubtitle, fontSizeModuleKey, fontSizeCaption, rightTitleBlockWidth } = this.state;
        const { classes, theme } = this.props;
        const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
        const { toolbaropt, menuopt, menuitemopt, iconbtnopt, position, ...otherOptions } = options
        let alignchildren = {
            left: [],
            right: [],
            title: [],
            drawer: [],
            isresponsive: [],
            isnotresponsive: [],
            inhead: []
        }
        components.forEach(each => {
            const { type, defaults, options } = each
            const { alignitem, isresponsive } = options
            const EachComp = compmap[each.type]
            const child = <EachComp {...each} key={each.key} compmap={compmap} />
            if (alignitem === 'left') {
                alignchildren.left.push(child)
                if (isresponsive === undefined) {
                    alignchildren.isnotresponsive.push(child)
                }
            }
            if (alignitem === 'right') {
                alignchildren.right.push(child)
                if (isresponsive === undefined) {
                    alignchildren.isresponsive.push(child)
                }
            }
            if (alignitem === 'title') {
                alignchildren.title.push(child)
                if (isresponsive === undefined) {
                    alignchildren.inhead.push(child)
                }
            }
            if (alignitem === 'drawer') {
                alignchildren.drawer.push(child)
                if (isresponsive === undefined) {
                    alignchildren.inhead.push(child)
                }
            }
            if (isresponsive) {
                alignchildren.isresponsive.push(child)
            }
            else {
                if (isresponsive === false) {
                    alignchildren.isnotresponsive.push(child)
                }
            }
        })

        /**
       *********************************************************
       Description: Handles rendering the header for the mobiles.
       Required props:   options, components, compmap. Each component in components has a alignitem prop to layout the component.
           Another configuration is responsive can be added in the json to make the component responsive. When the screen size
           decreases all the header components that has isresponsive are pushed into a menu on button.
       limitations    : N/A
       *********************************************************
       **/
        
        return (
            <div className={classes.grow}>
                <CssBaseline />
                {this.props.user ? (
                <AppBar position={localStorage.getItem('menulistview') === 'Y' ? position : "fixed"} {...otherOptions} className={classes.appBar}
                    elevation={0}
                    >
                    <Toolbar variant="dense" {...toolbaropt}>
                        <div className={this.props.accessPermissions ? classes.sectionDesktop : classes.sectionNonDesktop} >
                            {this.props.user && <>   <img alt='' src={getEnvVariable('ModuleKey') === 'APPS' ? (getEnvVariable('AppBarHeaderLogo') || '') : (getLandingPagelogo() || '')} className="d-inline-block" width='auto' height='28px' />
                                {(localStorage.getItem('menulistview') ? localStorage.getItem('menulistview') !== 'Y' : this.state.moveSidebartoTop === 'N') &&
                                    <IconButton
                                        style={{
                                            marginLeft: 40,
                                            color: 'white',
                                            padding: 4
                                        }}
                                        elevation={0}
                                        size='small'
                                        onClick={() => { this.props.leftmenuDrawerOpen(!this.props.leftmenuDrawer) }}
                                    >
                                        <MenuIcon style={{ color: 'white', fontSize: 18 }} />
                                    </IconButton>
                                }
                            </>
                            }
                            {/* Left Section with Title Styling */}
                            <div className="header-left-container" style={{
                                                   display: 'flex',
                                                   alignItems: 'center',
                                gap: '1rem'
                            }}>
                                <style>
                                    {`
                                        .header-left-container .MuiTypography-colorPrimary {
                                            color: white !important;
                                            text-shadow: 0 2px 10px rgba(0,0,0,0.5);
                                        }
                                        .header-left-container .MuiTypography-colorSecondary {
                                            color: rgba(255,255,255,0.8) !important;
                                            text-shadow: 0 1px 5px rgba(0,0,0,0.3);
                                        }
                                        .header-left-container .MuiTypography-root {
                                            color: white !important;
                                            text-shadow: 0 2px 10px rgba(0,0,0,0.5);
                                        }
                                        .header-left-container .MuiTypography-h4 {
                                            color: white !important;
                                            font-weight: 600;
                                            text-shadow: 0 2px 10px rgba(0,0,0,0.5);
                                        }
                                        .header-left-container .MuiTypography-caption {
                                            color: rgba(255,255,255,0.8) !important;
                                            text-shadow: 0 1px 5px rgba(0,0,0,0.3);
                                        }
                                    `}
                                </style>
                                {alignchildren.left}
                                           </div>
                            <div className="flex-grow-1" />
                            {this.props.accessPermissions && ((this.props.isTabView && this.props.isTabView === 'Y') || localStorage.getItem('menulistview') === 'Y') ? <SidebartabView /> : <>  </>}
                            <div className="flex-grow-1" />
                            {alignchildren.right}
                            {this.props.user && <Fragment>
                                <Fab
                                    disableElevation
                                    elevation={0}
                                    style={{
                                        background: 'rgba(255,255,255,0.1)',
                                        boxShadow: 'none',
                                        width: 28,
                                        height: 28,
                                        minHeight: 28
                                    }}
                                    size='small'
                                    className="m-1"
                                    title="Home"
                                    onClick={e => this.handleHomeClick(e)}
                                >
                                    <HomeIcon style={{ color: 'white', fontSize: 16 }} />
                                </Fab>
                                <Fab
                                    disableElevation
                                    elevation={0}
                                    title="Help"
                                    className=" mx-1"
                                    size='small'
                                    href={getEnvVariable('HelpUI')}
                                    target='_blank'
                                    style={{
                                        background: 'rgba(255,255,255,0.1)',
                                        boxShadow: 'none',
                                        width: 28,
                                        height: 28,
                                        minHeight: 28
                                    }}
                                >
                                    <SupportIcon style={{ color: 'white', fontSize: 16 }} />
                                </Fab>
                                <Fab
                                    disableElevation
                                    elevation={0}
                                    style={{
                                        background: 'rgba(255,255,255,0.1)',
                                        boxShadow: 'none',
                                        width: 28,
                                        height: 28,
                                        minHeight: 28
                                    }}
                                    size='small'
                                    title="Unread Notifications"
                                    className=" mx-1"
                                    onClick={e => this.handleNotificationClick(e)}
                                >
                                    {notification > 0 ? <Badge max="9999" badgeContent={(notification && (notification === 0 ? '0' : notification)) || localStorage.getItem('notificationCount') || '0'} color='secondary'>
                                        <NotificationIcon style={{ color: 'white', fontSize: 16 }} />
                                    </Badge> :
                                        <NotificationIcon style={{ color: 'white', fontSize: 16 }} />
                                    }
                                </Fab>

                                {/* {getEnvVariable("AccessPortal") !== 'E' && (this.props.accessPermissions.isRequestAdmin === 'Y') &&
                                           <Fab disableElevation elevation={0} style={{ backgroundColor: '#e8eaf6' }} size='small' title="Pending Registration Request" className=" mx-1" onClick={(e) => this.goToRegistrationRequest(e, true)}>
                                            {  totalCount > 0? <Badge badgeContent={totalCount && !(_.isNaN(totalCount)) ? totalCount.toString() : '0'} max={1000000000000}
                                                   color="error">
                                                   <HowToVoteIcon color='primary' />
                                               </Badge>
                                               : <HowToVoteIcon color='primary' />}
                                           </Fab>
                                       } */}

                                <Popover
                                    id="simple-popover"
                                    anchorEl={this.state.anchorEl}
                                    open={Boolean(this.state.anchorEl)}
                                    onClose={(e) => this.toggleDrawer(e, false)}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                >
                                </Popover>


                                {/* <QuickLinks /> */}
                                <RightDrawer accessPermissions={this.props.accessPermissions} compmap={compmap} userProfile={this.state.userProfile || null}
                                    handlefieldchange={(e) => this.handleMenuMovetoTOp(e)} mobile={true}
                                    handleNotificationClick={this.handleNotificationClick} />
                            </Fragment>
                            }
                        </div>
                        {this.props.accessPermissions && <div className={classes.sectionMobile}>
                            {/* {alignchildren.inhead}
                                                               <div /> */}
                            <img alt='' src={getEnvVariable('ModuleKey') === 'APPS' ? (getEnvVariable('AppBarHeaderLogo') || '') : (getLandingPagelogo() || '')} className="d-inline-block mt-1 me-3" width='auto' height='28px' />
                            {this.props.user && (localStorage.getItem('menulistview') ? localStorage.getItem('menulistview') !== 'Y' : this.state.moveSidebartoTop === 'N') && <>
                                <Fab
                                    className='float-end'
                                    style={{
                                        marginLeft: 10,
                                        marginTop: 3,
                                        background: 'rgba(255,255,255,0.1)',
                                        boxShadow: 'none',
                                        width: 28,
                                        height: 28,
                                        minHeight: 28
                                    }}
                                    size='small'
                                    onClick={() => { this.props.leftmenuDrawerOpen(!this.props.leftmenuDrawer) }}
                                >
                                    <MenuIcon style={{ color: 'white', fontSize: 16 }} />
                                </Fab></>}
                            {this.props.user && <>
                                <Fab
                                    disableElevation
                                    elevation={0}
                                    style={{
                                        background: 'rgba(255,255,255,0.1)',
                                        boxShadow: 'none',
                                        width: 28,
                                        height: 28,
                                        minHeight: 28
                                    }}
                                    size='small'
                                    className="m-1"
                                    title="Home"
                                    onClick={() => this.props.history.push('/')}
                                >
                                    <HomeIcon style={{ color: 'white', fontSize: 16 }} />
                                </Fab>
                                <SidebartabView isMobileMenuOpen={true} />
                                {/* <QuickLinks isMobile={true} /> */}
                            </>}
                            <RightDrawer accessPermissions={this.props.accessPermissions} compmap={compmap} userProfile={this.state.userProfile || null}
                                handlefieldchange={(e) => this.handleMenuMovetoTOp(e)} mobile={true}
                                handleNotificationClick={this.handleNotificationClick}
                            />
                        </div>}
                    </Toolbar>
                    {this.props.user && this.props.parentcomponents && this.props.parentcomponents.find(each => each.type === 'drawer') &&
                        < Sidebar  {...this.props.parentcomponents.find(each => each.type === 'drawer')} key={(this.props.components.find(each => each.type === 'drawer') || {}).key}
                            AccessPortal={getEnvVariable('AccessPortal')} compmap={compmap} accessPermissions={this.props.accessPermissions}
                            accessLevelPermissions={this.props.accessLevelPermissions} openSidebarDisplay={this.state.openSidebarDisplay} />
                    }
                </AppBar>) : null}

            </div >
        )

    }

}

MuiEdgeLayout.propTypes = {
    classes: PropTypes.object.isRequired,
};
MuiEdgeLayout = withStyles(styles)(MuiEdgeLayout);
const mapProps = (state) => {
    return {
        user: state.authentication.user, profile: state.authentication.profile,
        leftmenuDrawer: (state.header && state.header.leftmenuDrawer ? state.header.leftmenuDrawer : false),
        isTabView: (state.header && state.header.movebartoTop ? state.header.movebartoTop : false),
        notification: (state.header && state.header.notifications) || 0,
        totalCount: (state.header && state.header.totalCount) || 0,
        // notification2: (state.header && state.header.notifications) || 0
    }
}
const mapActions = dispatch => {
    return bindActionCreators({ setNotifications, getProjectMessages, setProfile, leftmenuDrawerOpen, moveSidebartoTop }, dispatch);
}

MuiEdgeLayout = connect(mapProps, mapActions)(MuiEdgeLayout);
export default withRouter(MuiEdgeLayout);
